import { cn } from '../../lib/utils';
import { Spinner } from './spinner';

interface LoadingScreenProps {
  message?: string;
  className?: string;
}

function LoadingScreen({ message = 'Loading...', className }: LoadingScreenProps) {
  return (
    <div className={cn('min-h-screen bg-gray-50 flex items-center justify-center', className)}>
      <div className="text-center">
        <Spinner size="lg" className="text-[var(--color-brand-primary)] mx-auto mb-4" />
        <p className="text-gray-600 text-sm">{message}</p>
      </div>
    </div>
  );
}

export { LoadingScreen, type LoadingScreenProps };
